import axios from "axios";
import BaseTra from "../baseTra";
import { logMimiTra } from "../../speech-service-log/log";

export default class MimiTra extends BaseTra {

    /**
     * @type {string}
     * @protected
     */
    _authToken;

    /**
     *
     * mimi TRA api params without "text" field
     * @see {@link https://mimi.readme.io/reference/machine-translation}
     *
     * @type {Object}
     * @protected
     */
    _params;

    /**
     * @type {string}
     * @protected
     */
    _url = 'https://tra.mimi.fd.ai/machine_translation'

    constructor(accessToken, params){
        super();
        this._authToken = accessToken;
        this._params = params;
    }

    updateAuthToken(accessToken){
        this._authToken = accessToken;
    }

    async translate(text){
        const {source_lang: sourceLang, target_lang: targetLang} = this._params;

        if(sourceLang === targetLang){
            return text;
        }

        try {
            const data = {
                ...this._params,
                ...{
                  text,
                },
              };

              const formData = Object.entries(data).reduce((formData, [k, v]) => {
                formData.append(k, v);
                return formData;
              }, new FormData());

              const res = await axios.post(this._url, formData, {
                headers: {
                  accept: "application/json",
                  Authorization: "Bearer " + this._authToken,
                },
              });

              logMimiTra(res.data);

              return res.data;
        } catch (err) {
            console.error(err);
        }
    }

    static fromToken(token, sourceLang, targetLang){
        return new MimiTra(token, {
            source_lang: sourceLang,
            target_lang: targetLang
        });
    }
}
